import React, { useMemo } from 'react';

import Modal from 'components/Modal';
import Pill from 'components/Misc/Pill';
import Avatar from 'components/Misc/Avatar';
import { Title } from 'components/Misc/Typography';
import { Form } from 'components/Misc/Form';

const Edit = ({ id, takes, handleEdit }) => {
	// Find current take
	const take = useMemo(() => takes?.find(take => take.id === id), [id, takes]);

	// Handle modal's visibility
	const handleModal = () => handleEdit(0);

	return (
		<Modal title="Labot studenta datus" visible={id} handleModal={handleModal}>
			<div className="py-3 flex items-center">
				<Avatar
					alt={take?.student.fullName}
					src={take?.student.avatar}
				/>

				<Title
					title={take?.student.fullName}
					subtitle={take?.student.status}
					className="ml-3 flex-1"
				/>

				<Pill
					theme={take?.state === 'assigned' ? '' : 'success'}
					name={take?.state === 'active' ? 'Aktīvs' : take?.state}
				/>
			</div>
				
			<Form>
				Labot info
			</Form>
		</Modal>
	);
};

export default Edit;